import React from 'react';

/**
 * The only two moderation states a note's author is ever shown. The API
 * already sends authors 'approved' or 'pending'; this mapping also covers raw
 * statuses so an author-facing view never shows "Rejected" or "AI Approved",
 * whatever it is given.
 */
export type AuthorNoteStatus = 'approved' | 'pending';

export const toAuthorStatus = (status?: string | null): AuthorNoteStatus =>
  status === 'approved' || status === 'ai-approved' || status === 'moderator-approved' ? 'approved' : 'pending';

export const AUTHOR_STATUS_LABEL: Record<AuthorNoteStatus, string> = {
  approved: 'Approved',
  pending: 'Pending'
};

const AUTHOR_STATUS_CLASS: Record<AuthorNoteStatus, string> = {
  approved: 'bg-success',
  pending: 'bg-warning text-dark'
};

/** "Approved" or "Pending" badge for author-facing views. */
export const AuthorStatusBadge: React.FC<{ status?: string | null }> = ({ status }) => {
  const shown = toAuthorStatus(status);
  return (
    <span className={`badge ${AUTHOR_STATUS_CLASS[shown]}`} data-testid="author-status-badge">
      {AUTHOR_STATUS_LABEL[shown]}
    </span>
  );
};
